import {Box, Stack, Table, TableCell, TableRow, styled} from '@mui/material';

export const Card = styled(Box)(({theme}) => ({
	backgroundColor: theme.colors.brand.primary.white,
	padding: '12px 20px',
	borderRadius: 8,
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
}));

export const StyledTable = styled(Table)({
	'& .MuiTableCell-root': {
		border: 'none',
	},
});

export const StyledTableHeadRow = styled(TableRow)({
	'& .MuiTableCell-root': {
		padding: '12px 8px',
		borderRadius: 8,
	},
});

export const StyledTableBodyRow = styled(TableRow)(({theme}) => ({
	'& .MuiTableCell-root': {
		padding: '12px 8px',
		borderRadius: 0,
	},
	'& .MuiTableCell-root:first-of-type': {
		borderRadius: '8px 0 0 8px',
	},
	'& .MuiTableCell-root:last-of-type': {
		borderRadius: '0 8px 8px 0',
	},
	'&:nth-of-type(odd) .MuiTableCell-root': {
		backgroundColor: theme.colors.gray['05Percent'],
	},
	'&:nth-of-type(even) .MuiTableCell-root': {
		backgroundColor: theme.colors.brand.primary.white,
	},
}));

export const StyledTableCell = styled(TableCell)({
	padding: '12px 8px',
	borderRadius: 8,
});

export const MobileCard = styled(Box)(({theme}) => ({
	backgroundColor: theme.colors.brand.primary.white,
	borderRadius: 8,
	padding: 16,
	display: 'flex',
	flexDirection: 'column',
	gap: 12,
}));

export const MobileCardRow = styled(Stack)({
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	gap: 8,
});

export const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;
